import { PricingService as PricingApi } from '../../BackEnd/API';

export const PricingService = {
  getCandles: (symbol, timeFrame, { from, to } = {}) => {
    let url = `/api/v1/pricing/candles/${symbol}/${timeFrame}`;

    if (from && !to) {
      url += `?from=${from}`;
    } else if (from && to) {
      url += `?from=${from}&to=${to}`;
    }

    return PricingApi.get(url);
  },
  getQuotes: (symbol, { from, to } = {}) => {
    let url = `/api/v1/pricing/quotes/${symbol}`;

    if (from && !to) {
      url += `?from=${from}`;
    } else if (from && to) {
      url += `?from=${from}&to=${to}`;
    }

    return PricingApi.get(url);
  },
};
